import React, { FC } from 'react';
import { Form } from 'react-bootstrap';
import { Button, ValidationForm } from '../../atoms';
import { ParticipantResponseDto } from '../../../store/landscapeAPI/participant/dto/response/participant-response.dto';
import { CustomDropdown } from '../../molecules';
import { ParticipantOrganisationType } from '../../../store/landscapeAPI/participant/participant-organisation-type';
import cn from 'classnames';
import styles from './LandscapeAboutParticipantOrganism.module.css';

interface LandscapeAboutParticipantOrganismProps {
  handleOnChange: (participant: ParticipantResponseDto) => void;
  participant: ParticipantResponseDto;
  callbackFn: (participant: ParticipantResponseDto) => void;
}

const LandscapeAboutParticipantOrganism: FC<
  LandscapeAboutParticipantOrganismProps
> = ({ handleOnChange, participant, callbackFn }) => {
  const participantOrganisationTypes = [
    ParticipantOrganisationType.CivilSociety,
    ParticipantOrganisationType.Donors,
    ParticipantOrganisationType.FinancialServices,
    ParticipantOrganisationType.PrivateSector,
    ParticipantOrganisationType.Producers,
    ParticipantOrganisationType.PublicSector,
  ];

  const dropDownItems = participantOrganisationTypes.map((type) => ({
    eventKey: type,
    label: type.toString(),
  }));

  const initialTitle = dropDownItems.find(
    (dropDownItem) => dropDownItem.eventKey === participant.organisationType
  )?.label;

  return (
    <div className={cn(styles.landscapeWrapper)}>
      <ValidationForm onSubmitCallback={() => callbackFn(participant)}>
        <Form.Group className="mb-3">
          <Form.Label>Name</Form.Label>
          <Form.Control
            required
            type="text"
            placeholder="Enter name"
            onChange={(e) =>
              handleOnChange({ ...participant, name: e.target.value })
            }
            value={participant.name}
          />
          <Form.Control.Feedback type="invalid">
            Please provide a valid name
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Url (it must start with http:// or https://)</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter url"
            onChange={(e) =>
              handleOnChange({ ...participant, url: e.target.value })
            }
            value={participant.url ?? ''}
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Landscape status</Form.Label>
          <CustomDropdown
            items={dropDownItems}
            initialTitle={
              initialTitle ?? ParticipantOrganisationType.CivilSociety
            }
            onSelectOption={(e) => {
              let type = ParticipantOrganisationType.CivilSociety;
              if (e.eventKey === 'Donors')
                type = ParticipantOrganisationType.Donors;
              if (e.eventKey === 'FinancialServices')
                type = ParticipantOrganisationType.FinancialServices;
              if (e.eventKey === 'PrivateSector')
                type = ParticipantOrganisationType.PrivateSector;
              if (e.eventKey === 'Producers')
                type = ParticipantOrganisationType.Producers;
              if (e.eventKey === 'PublicSector')
                type = ParticipantOrganisationType.PublicSector;
              handleOnChange({ ...participant, organisationType: type });
            }}
          />
          <Form.Control.Feedback type="invalid">
            Please provide landscape status
          </Form.Control.Feedback>
        </Form.Group>
        <Button /*onClick={handleSubmit}*/ variant="dark" type="submit">
          Save
        </Button>
      </ValidationForm>
    </div>
  );
};

export default LandscapeAboutParticipantOrganism;
